import { HasId } from '../common';

export interface Tag extends HasId {
    title: string;
}

export const FEATURED_TEMPLATE_TAG_TITLE = 'featured';
